export default __webpack_public_path__ + "media/avatars/05-f782677a.png";